export default function groupedRows() {
  $(document).on('click', '.show-grouped-rows-link', function(e){
    e.preventDefault();
    const $this = $(this),
        wrapper = $this.closest('.show-grouped-rows').next();

    wrapper.slideToggle(
        200,
        function() {
            $this.toggleClass('to-hide');
          if (wrapper.is(":visible")){
            $this.html($this.data('hide'));
          }
          if (wrapper.is(":hidden")){
            $this.html($this.data('show'));
          }
        }
    );
  });
}